import { type EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { AuthService } from '@frontendlib/common/services/auth.service';
import { PermissionsService } from '@frontendlib/common/features/permissions/services/permissions.service';
import { SubscriptionLiveUpdatesService } from '@modules/common/services/subscription-live-updates.service';
import { CollectionRefusalService } from '@modules/settings/services/collection-refusal.service';

/**
 * The main app's bootstrap work. It runs on EVERY first load, public pages included (`/join/<token>`,
 * `/shared/...`), so whatever it starts must survive a visitor with no session (#2333). Exported so
 * the join-page integration spec boots the same code the app does.
 */
export function provideMainAppInitializer(): EnvironmentProviders {
  return provideAppInitializer(() => {
    if (inject(AuthService).isAuthenticated()) {
      inject(PermissionsService).loadPermissionRules(); // eager preload
    }
    // Instantiated here rather than by a component, because the state it refreshes is app-wide and has no mounted subscriber to depend on.
    inject(SubscriptionLiveUpdatesService);
    // Listening before Billing mounts, so a refusal that lands during the redirect still lifts the banner.
    inject(CollectionRefusalService);
  });
}
